/**
 * Heurísticas de pressão de memória/fila.
 */

import type { QueueItem } from '../queue';

export interface MemoryPressureSnapshot {
  level: number;
  queueSize: number;
  retryStorm: boolean;
  enqueueRateHigh: boolean;
}

let recentEnqueueTimestamps: number[] = [];

export function recordEnqueueForPressure(): void {
  const now = Date.now();
  recentEnqueueTimestamps.push(now);
  recentEnqueueTimestamps = recentEnqueueTimestamps.filter(t => now - t < 60_000);
}

export function computeMemoryPressure(
  queue: QueueItem[],
  maxQueueSize: number
): MemoryPressureSnapshot {
  const queueSize = queue.length;
  const retrying = queue.filter(
    i => i.status === 'failed' || (i.nextRetryAt != null && i.nextRetryAt > Date.now())
  ).length;
  const retryStorm = retrying > Math.max(10, queueSize * 0.4);
  const enqueueRateHigh = recentEnqueueTimestamps.length > 80;
  let level = queueSize / Math.max(1, maxQueueSize);
  if (retryStorm) level = Math.min(1, level + 0.2);
  if (enqueueRateHigh) level = Math.min(1, level + 0.15);
  return {
    level: Math.min(1, level),
    queueSize,
    retryStorm,
    enqueueRateHigh,
  };
}

export function _testResetPressure(): void {
  recentEnqueueTimestamps = [];
}
